/* eslint-disable */
import config from '../../config'
import { useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import Breadcrumb from '../../components/core/breadcrumb'
import PageTitle from '../../components/core/pageTitle'
import { Button } from '../../components/core/button'
import { PageContext } from '../../context/PageContextProvider'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'

const Personal = ({ className }) => {
  const crumbs = [
    {
      link: '/',
      text: {
        AZ: 'Ana Səhifə',
        ENG: 'Home',
        RU: 'Главная страница',
        TR: 'Ana Sayfa',
      },
    },
    {
      link: '#',
      text: {
        AZ: 'Direktorlara Məsləhət Xidməti',
        ENG: 'CEO Advice Service',
        RU: 'Консультационные услуги генерального директора',
        TR: 'Yöneticilere Danışmanlık Hizmeti',
      },
    },
  ]
  const { language } = useContext(PageContext)
  const DEFAULT_DATA = {
    title: {
      AZ: 'Biznes Sahibləri və Direktorları üçün Məsləhət Xidmətləri',
      ENG: 'Consulting Services for Business Owners & Directors',
      RU: 'Консультационные услуги для владельцев бизнеса и директоров',
      TR: 'İşletme Sahipleri ve Yöneticiler İçin Danışmanlık Hizmetleri',
    },
    description_az: '<p>Biznes proseslərinizdə qarşılaşdığınız idarəetmə, maliyyə və əməliyyat məsələlərini birlikdə təhlil edir, qərarverməni gücləndirən və biznesinizin daha sistemli idarə olunmasına kömək edən praktik məsləhətlər təqdim edirik.</p>',
    description_eng: '<p>We analyze management, financial, and operational issues in your business processes together, offering practical advice that strengthens decision-making and helps manage your business systematically.</p>',
    description_ru: '<p>Мы вместе анализируем управленческие, финансовые и операционные вопросы в ваших бизнес-процессах, предоставляя практические рекомендации для систематического управления бизнесом.</p>',
    description_tr: '<p>İş süreçlerinizde karşılaştığınız yönetim, finansal ve operasyonel zorlukları birlikte analiz ediyor, karar alma mekanizmanızı güçlendiren ve işinizin daha sistemli yönetilmesine katkı sağlayan pratik danışmanlık hizmetleri sunuyoruz.</p>',
  }
  const [load, setLoad] = useState(true)
  const [data, setData] = useState(DEFAULT_DATA)
  const linkBuilder = (url) => {
    if (!url) return ''
    if (url.startsWith('http://') || url.startsWith('https://')) return url
    return `${config.API_URL}${url.startsWith('/') ? '' : '/'}${url}`
  }
  useEffect(() => {
    (async () => {
      try {
        const res = await PagesAPI.getPersonalDevPage()
        if (res?.data && res.data.title) {
          setData(res.data)
        }
      } catch (e) {
        console.warn('Using default Personal page data')
      }
    })()
  }, [])
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <div>
        <Breadcrumb crumbs={crumbs} />
        <PageTitle>{data?.title?.[language] || data?.title?.TR || data?.title?.AZ || ''}</PageTitle>
        <p
          dangerouslySetInnerHTML={{
            __html:
              language === 'AZ'
                ? data?.description_az
                : language === 'TR'
                ? (data?.description_tr || data?.description_az)
                : language === 'ENG'
                ? data?.description_eng
                : (data?.description_ru || data?.description_az),
          }}
        />
        <img
          src={linkBuilder(data?.photoLocation)}
          alt="Personal Development"
        />
        <div style={{ marginTop: '36px', display: 'flex', justifyContent: 'center' }}>
          <Button to={'/get-service1'}>
            {language === 'AZ' ? 'Xidmət Sifariş Edin →' : language === 'TR' ? 'Hizmet Talep Edin →' : language === 'ENG' ? 'Request Service →' : 'Заказать услугу →'}
          </Button>
        </div>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Personal
